import React from "react";
import { motion } from "framer-motion";
import { ShieldCheckIcon } from "@heroicons/react/solid";

const steps = [
  { step: "01", title: "Discover", description: "Understand goals, users, and constraints before writing a line of code." },
  { step: "02", title: "Design", description: "Architecture and UX decisions that hold up as the product grows." },
  { step: "03", title: "Build", description: "Ship working software in tight, reviewable iterations." },
  { step: "04", title: "Launch & Support", description: "Deploy, monitor, and keep improving after go-live." },
];

const CodehouzeAbout = () => {
  return (
    <section id="about" className="py-24 bg-gray-900">
      <div className="mx-auto max-w-4xl px-6 text-center">
        <div className="flex flex-col items-center mb-10">
          <ShieldCheckIcon className="w-8 h-8 text-codehouzeOrange mb-4" />
          <h2 className="text-3xl sm:text-4xl font-bold text-white">Who We Are</h2>
          <div className="codehouze-divider" />
        </div>

        <p className="text-gray-400 text-lg leading-relaxed mb-6">
          Codehouze Technology Solutions is a software development and consulting
          studio built on one principle: ship products that work, on time, without
          cutting corners on quality or security.
        </p>

        <p className="text-gray-500 text-base leading-relaxed mb-16">
          We work directly with founders and product teams, as an extension of
          your team rather than a black-box vendor, to turn requirements into working
          software, whether that's a first MVP or a platform serving thousands of
          users.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 text-left">
          {steps.map(({ step, title, description }, i) => (
            <motion.div
              key={step}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="relative p-5 rounded-2xl bg-white/[0.03] border border-white/10"
            >
              <span className="codehouze-text-gradient text-2xl font-bold">{step}</span>
              <h3 className="text-white font-semibold mt-2 mb-1">{title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CodehouzeAbout;
